/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_Memory_Item1Inputs */

const en_mk_mock_memory_item1 = /** @type {(inputs: Mk_Mock_Memory_Item1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call customers “Sobat Nusa”`)
};

const id_mk_mock_memory_item1 = /** @type {(inputs: Mk_Mock_Memory_Item1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panggil pelanggan “Sobat Nusa”`)
};

/**
* | output |
* | --- |
* | "Call customers “Sobat Nusa”" |
*
* @param {Mk_Mock_Memory_Item1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_memory_item1 = /** @type {((inputs?: Mk_Mock_Memory_Item1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_Memory_Item1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_memory_item1(inputs)
	return en_mk_mock_memory_item1(inputs)
});